module.exports = __webpack_public_path__ + "img/50h100_gluhoe.12050dce.svg";